import { Stack, Typography, Button, Box, Checkbox, Tooltip, InputAdornment, OutlinedInput, FormControl, InputLabel } from "@mui/material";
import * as React from "react";
import InputControl from "../../../shared/components/InputControl";
import { useEffect } from "react";

export const ProductSizeDialog = (props) => {
  const {
    data,
    HandleVarientChange,
    onSubmit,
    validator,
    variants,
    isBusy,
    tenantPreferredLanguages = [],
    regionState,
  } = props;

  const languages = tenantPreferredLanguages.map((language) => {
    const code = typeof language === "string" ? language : language.code;
    const option = regionState?.languagesOptions?.find(
      (item) => item.code === code
    );

    return { code, name: option?.name || code };
  });

  useEffect(() => {
    if (!variants.length) {
      HandleVarientChange({
        target: { name: "default", value: 1 },
      });
    }
  }, [variants]);
  return (
    <Stack
      sx={{
        mt: "24px",
        height: "100%",
        justifyContent: "space-between",
      }}
    >
      <Box>
        {languages.map((language) => {
          const value = data.locale_name?.[language.code] || "";
          const fieldName = `Variant Name (${language.name})`;

          return (
            <Stack
              key={language.code}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              minHeight="72px"
            >
              <Typography variant="subtitle1">{language.name}</Typography>
              <InputControl
                label={`${language.name} Name`}
                name={`locale_name.${language.code}`}
                width="273px"
                value={value}
                onChange={HandleVarientChange}
                error={validator.current.message(fieldName, value, "required")}
                helperText={validator.current.message(
                  fieldName,
                  value,
                  "required"
                )}
              />
            </Stack>
          );
        })}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          height="72px"
        >
          <Typography variant="subtitle1">PLU Code</Typography>
          <FormControl>
            <InputLabel id="plu">PLU Code</InputLabel>
            <OutlinedInput
              name="plu"
              label="PLU Code"
              value={data.plu}
              onChange={HandleVarientChange}
              placeholder="PLU Code"
              sx={{ width: "273px" }}
              endAdornment={
                <InputAdornment position="start">
                  <Tooltip title="If left empty, will be auto-generated.">
                    <img alt="details" src="/icons/ic_info.svg" />
                  </Tooltip>
                </InputAdornment>
              }
            />
          </FormControl>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          height="72px"
        >
          <Typography variant="subtitle1">Old PLU Code</Typography>

          <InputControl
            label="Old PLU code"
            name="old_plu"
            width="273px"
            value={data.old_plu}
            onChange={HandleVarientChange}
          />
        </Stack>

        <Stack direction="row" alignItems="center" height="72px">
          <Typography variant="subtitle1" width="110px">
            Default
          </Typography>
          <Checkbox
            checked={data.default ? true : false}
            name="default"
            onChange={(e, v) =>
              HandleVarientChange({
                target: { name: "default", value: v ? 1 : 0 },
              })
            }
          />
        </Stack>
      </Box>
      <Button
        sx={{ height: "48px" }}
        variant="contained"
        fullWidth
        onClick={onSubmit}
        disabled={isBusy}
      >
        Save
      </Button>
    </Stack>
  );
};
